class ComponentClassNames {
    constructor() {
        this.initialClassNames = [...arguments];
    }

    addClassNames(...args) {
        this.initialClassNames = this.initialClassNames
            .concat([...args]);
    }

    removeClassNames(...args) {
        this.initialClassNames = this.initialClassNames
            .filter((className) => args.indexOf(className) !== -1);
    }

    getClassName() {
        return this.initialClassNames.join(' ');
    }
}

export { ComponentClassNames };